import { useCallback } from 'react';

export const useInputArrowNavigation = (inputID: string, idPrefix: string) =>
  useCallback(
    (direction: 'up' | 'down') => {
      const allInputs = Array.from(
        document.querySelectorAll<HTMLInputElement>(`[id^="${idPrefix}"]`),
      );
      const currentIndex = allInputs.findIndex((el) => el.id === inputID);
      if (currentIndex === -1) {
        return;
      }
      const targetIndex =
        direction === 'down' ? currentIndex + 1 : currentIndex - 1;
      allInputs[targetIndex]?.focus();
    },
    [idPrefix, inputID],
  );
